import * as React from 'react';

import { CallHistoryMethodAction } from 'connected-react-router';
import Typography from '@components/basics/typography';
import Button from '@components/actions/button';
import styled, { css } from 'styled-components';
import { getWidth } from '@components/styles';
import { Translate } from 'react-localize-redux';

export interface SummaryButtonProps {
  className?: string;
  fixed?: boolean;
  noPadding?: boolean;
  onClick: () => CallHistoryMethodAction;
}

export const SummaryButton: React.FC<SummaryButtonProps> = (props) => {
  return (
    <div className={props.className}>
      <Button
        customHeight={40}
        isPillShape
        className="goto-summary-button"
        buttonType="empty"
        color={'black'}
        onClick={props.onClick}
      >
        <Typography type="section-title">
          <Translate id="BUTTON.COMMON.GO_TO_SUMMARY" />
        </Typography>
      </Button>
    </div>
  );
};

export default styled(SummaryButton)`
  position: fixed;
  width: 100%;
  max-width: 1440px;
  bottom: ${(props) => (props.fixed ? '0' : 'inherit')};
  left: 48%;
  margin-bottom: 10px;
  box-sizing: border-box;
  transform: translate(-50%, 0);
  pointer-events: none;
  padding: 0 30px;
  z-index: 30;

  ${(props) =>
    props.noPadding
      ? css`
          padding: 0;
        `
      : null}

  @media ${({ theme }) => theme.device.tablet} {
    padding: 0;
    padding-right: 30px;
  }

  @media ${({ theme }) => theme.device.desktopL} {
    max-width: 2560px;
  }

  & > button {
    pointer-events: all;
    width: 100%;
    max-width: none;

    @media ${({ theme }) => theme.device.mobileS} {
      max-width: ${getWidth(6.5)};
      margin: 0 auto;
      display: block;
    }

    @media ${({ theme }) => theme.device.tablet} {
      float: right;
      max-width: ${getWidth(3)};
    }
  }
  .goto-summary-button {
    max-width: 180px;
  }
`;
